import React from 'react';
import {
  Box,
  Container,
  Typography,
  Button,
  Grid,
  Card,
  CardContent,
  CardMedia,
  useTheme,
  useMediaQuery
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import {
  Timeline,
  Assessment,
  Group,
  VideoLibrary
} from '@mui/icons-material';

const Home = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const navigate = useNavigate();

  const features = [
    {
      icon: <Timeline sx={{ fontSize: 40 }}/>,
      title: 'Track Progress',
      description: 'Monitor your journey through Gracie Combatives with detailed progress tracking.'
    },
    {
      icon: <Assessment sx={{ fontSize: 40 }}/>,
      title: 'Performance Analytics',
      description: 'View detailed statistics and insights about your training journey.'
    },
    {
      icon: <Group sx={{ fontSize: 40 }}/>,
      title: 'Community',
      description: 'Connect with fellow students and share your experiences.'
    },
    {
      icon: <VideoLibrary sx={{ fontSize: 40 }}/>,
      title: 'Video Access',
      description: 'Quick access to Gracie University training videos.'
    }
  ];

  return (
    <Box sx={{ bgcolor: 'background.default' }}>
      {/* Hero Section */}
      <Box
        sx={{
          height: isMobile ? '60vh' : '80vh',
          position: 'relative',
          overflow: 'hidden',
          display: 'flex',
          alignItems: 'center',
          background: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.7)), url('/images/bjj-hero.jpg')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      >
      {/* <Box
          component="video"
          autoPlay
          muted
          loop
          playsInline
          poster="/images/video-poster.jpg"
          sx={{
            width: '100%',
            borderRadius: 2,
            boxShadow: 3
          }}
        >
          <source src="/videos/bjj-preview.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </Box> */}
        <Container maxWidth="lg">
          <Box sx={{ color: 'white', maxWidth: 600 }}>
            <Typography 
              variant={isMobile ? "h3" : "h2"} 
              component="h1" 
              gutterBottom
              sx={{ fontWeight: 'bold' }}
            >
              Track Your Jiu-Jitsu Journey
            </Typography>
            <Typography variant="h5" paragraph>
              Master Gracie Combatives systematically with our comprehensive tracking system.
            </Typography>
            <Button 
              variant="contained" 
              size="large"
              onClick={() => navigate('/register')}
              sx={{ 
                mt: 2,
                bgcolor: theme.palette.primary.main,
                '&:hover': {
                  bgcolor: theme.palette.primary.dark,
                }
              }}
            >
              Start Your Journey
            </Button>
          </Box>
        </Container>
      </Box>

      {/* Features Section */}
      <Container maxWidth="lg" sx={{ py: 8 }}>
        <Grid container spacing={4}>
          {features.map((feature, index) => (
            <Grid item xs={12} sm={6} md={3} key={index}>
              <Card 
                sx={{ 
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  textAlign: 'center',
                  p: 2,
                  transition: '0.3s',
                  '&:hover': {
                    transform: 'translateY(-5px)',
                    boxShadow: 4
                  }
                }}
              >
                <Box sx={{ 
                  color: 'primary.main',
                  mb: 2
                }}>
                  {feature.icon}
                </Box>
                <CardContent>
                  <Typography gutterBottom variant="h5" component="h2">
                    {feature.title}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {feature.description}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>

      {/* Video Section */}
      <Box sx={{ bgcolor: 'grey.100', py: 8 }}>
        <Container maxWidth="lg">
          <Grid container spacing={4} alignItems="center">
            <Grid item xs={12} md={6}>
              <Box
                component="video"
                autoPlay
                muted
                loop
                playsInline
                poster="/images/video-poster.jpg"
                sx={{
                  width: '100%',
                  borderRadius: 2,
                  boxShadow: 3
                }}
              >
                <source src="/videos/bjj-preview.mp4" type="video/mp4" />
                Your browser does not support the video tag.
              </Box>
            </Grid>
            <Grid item xs={12} md={6}>
              <Typography variant="h3" gutterBottom>
                Learn. Track. Progress.
              </Typography>
              <Typography variant="body1" paragraph>
                Follow the Gracie Combatives curriculum step by step, track your progress,
                and achieve your goals with our comprehensive tracking system.
              </Typography>
              <Button 
                variant="contained" 
                size="large"
                onClick={() => navigate('/login')}
              >
                Start Training Now
              </Button>
            </Grid>
          </Grid>
        </Container>
      </Box>
    </Box>
  );
};

export default Home; 